export const coverageDefinition = (variant: "msp" | "tenant"): string => {
  return variant === "msp"
    ? "Healthy in-scope browsers over in-scope browsers, by tenant"
    : "Healthy in-scope browsers over in-scope browsers";
};
